import { __assign, __extends } from 'tslib';
import { findDomFromVNode, removeVNodeDom, insertOrAppend, createVNode, createComponentVNode, validateProps, Component as Component$1, callAll } from 'intact';
export * from 'intact';
import Vue from 'vue';
import { isNullOrUndefined, isArray, isStringOrNumber, hasOwn, EMPTY_OBJ, noop } from 'intact-shared';

var _textVNode = Vue.prototype._v('');
var VueVNode = _textVNode.constructor;
var patch = Vue.prototype.__patch__;
var Wrapper = /*#__PURE__*/ /*#__PURE__*/ /** @class */ (function () {
    function Wrapper($props, $vNode, $SVG, $mountedQueue, $senior) {
        this.$props = $props;
        this.$vNode = $vNode;
        this.$SVG = $SVG;
        this.$mountedQueue = $mountedQueue;
        this.$senior = $senior;
        this.$inited = true;
        this.$lastInput = createVNode('fake-div');
    }
    Wrapper.prototype.$init = function (props) { };
    Wrapper.prototype.$render = function (lastVNode, vNode, parentDom, anchor) {
        if (lastVNode) {
            anchor = findDomFromVNode(lastVNode, true).nextSibling;
            removeVNodeDom(lastVNode, parentDom);
        }
        else if (!parentDom) {
            parentDom = document.createDocumentFragment();
        }
        var vnode = getVueVNode(this, vNode);
        var dom = this.patch(null, vnode);
        insertOrAppend(parentDom, dom, anchor);
    };
    Wrapper.prototype.$update = function (lastVNode, vNode, parentDom, anchor) {
        // debugger;
        var lastVnode = lastVNode.props.vnode;
        var nextVnode = getVueVNode(this, vNode);
        this.patch(lastVnode, nextVnode);
    };
    Wrapper.prototype.$unmount = function (vNode, nextVNode) {
        // unmount(vNode.props!.vnode, getParent(this), null, !!nextVNode);
        patch(vNode.props.vnode, null, false, false);
    };
    Wrapper.prototype.patch = function (lastVnode, nextVnode) {
        var realNextVnode = nextVnode;
        if (lastVnode) {
            // fake a parent vnode to let vue patch the children
            var realLastVnode = lastVnode;
            lastVnode = new VueVNode('div', null, [realLastVnode], null, lastVnode.elm.parentElement);
            lastVnode.parent = realLastVnode.parent;
            nextVnode = new VueVNode('div', null, [realNextVnode]);
            nextVnode.parent = realNextVnode.parent;
        }
        patch(lastVnode, nextVnode, false, false);
        var parent = nextVnode.parent;
        var data = parent.data;
        if (data.pendingInsert && data.pendingInsert !== data.queue) {
            /**
             * Every time we call patch function, it will create a insertedQueue
             * and assign it to parent.data.pendingInsert. If the parent has multiple
             * Wrapper elements, the pendingInsert will be overwrite by next Wrapper.
             * So will should store the queue
             */
            var queue = data.queue || (data.queue = []);
            queue.push.apply(queue, data.pendingInsert);
            // maybe the pendingInsert has been overwrite
            data.pendingInsert = queue;
        }
        // add dom to the $lastInput for findDomFromVNode
        var lastInput = this.$lastInput;
        var dom = realNextVnode.elm;
        lastInput.dom = dom;
        lastInput.type |= 8192; /* InUse */
        return dom;
    };
    return Wrapper;
}());
function getParentNode(instance) {
    var $senior = instance.$senior;
    do {
        var $vnode = $senior.$vnode;
        if ($vnode) {
            return $vnode;
        }
    } while ($senior = $senior.$senior);
    // should not hit this
    /* istanbul ignore next */
    return null;
}
function getVueVNode(instance, vNode) {
    var props = vNode.props;
    var vnode = props.vnode;
    // if we are reusing the vNode, clone it
    var hasCloned = false;
    if (vnode.elm) {
        vnode = cloneVNode(vnode);
        hasCloned = true;
    }
    for (var key in props) {
        if (key === 'vnode')
            continue;
        // clone the vnode at first
        if (!hasCloned) {
            vnode = cloneVNode(vnode);
            hasCloned = true;
        }
        if (!vnode.data) {
            vnode.data = {};
        }
        else {
            vnode.data = __assign({}, vnode.data);
        }
        var data = vnode.data;
        var value = props[key];
        if (key === 'className') {
            data.staticClass = value;
            // should not delete the class, it is the dynamic classNames
            // delete data.class;
        }
        else if (key.substr(0, 3) === 'ev-') {
            if (!data.on) {
                data.on = {};
            }
            else {
                data.on = __assign({}, data.on);
            }
            data.on[key.substr(3)] = value;
        }
        else {
            if (!data.attrs) {
                data.attrs = {};
            }
            else {
                data.attrs = __assign({}, data.attrs);
            }
            data.attrs[key] = value;
        }
    }
    vNode.props = __assign(__assign({}, props), { vnode: vnode });
    vnode.parent = getParentNode(instance);
    return vnode;
}
// copy from vue/src/core/vdom/vnode.js
function cloneVNode(vnode) {
    var cloned = new VueVNode(vnode.tag, 
    // clone data
    vnode.data ? __assign({}, vnode.data) : vnode.data, 
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, 
    // vnode.elm,
    null, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}

function beforeInsert(vNode, parent) {
    while (parent = parent === null || parent === void 0 ? void 0 : parent.$senior) {
        if (parent.$isVue) {
            var vnode = parent.$vnode;
            setScopeId(vNode.dom, vnode);
        }
    }
}
function setScopeId(el, vnode) {
    var i;
    if (!isNullOrUndefined(i = vnode.fnScopeId)) {
        hostSetScopeId(el, i);
    }
    else {
        var ancestor = vnode;
        while (ancestor) {
            if (!isNullOrUndefined(i = ancestor.context) && !isNullOrUndefined(i = i.$options._scopeId)) {
                hostSetScopeId(el, i);
            }
            ancestor = ancestor.parent;
        }
    }
}
function hostSetScopeId(el, scopeId) {
    el.setAttribute(scopeId, '');
}

var _testData = {};
new Vue({ data: _testData });
var __ob__ = _testData.__ob__;
function normalize(vnode) {
    if (isNullOrUndefined(vnode) || isStringOrNumber(vnode))
        return vnode;
    if (isBoolean(vnode))
        return String(vnode);
    if (isIntactVNode(vnode)) {
        // if (vnode.type & Types.InUse) {
        // return directClone(vnode);
        // }
        return vnode;
    }
    if (vnode.text !== undefined) {
        return vnode.text;
    }
    var vNode;
    if (isIntactComponent(vnode)) {
        var Ctor = vnode.componentOptions.Ctor;
        var props = normalizeProps(vnode);
        vNode = createComponentVNode(8 /* ComponentClass */, Ctor, props, vnode.key, props.ref);
        vNode.hooks = { beforeInsert: beforeInsert };
    }
    else {
        vNode = createComponentVNode(8 /* ComponentClass */, Wrapper, { vnode: vnode }, vnode.key);
    }
    // let vue don't observe it when it is used as property, ksc-fe/kpc#500
    // we can not use `vNode._isVue = true`, because it will affect vue-devtools. ksc-fe/kpc#512
    vNode.__ob__ = __ob__;
    return vNode;
}
function normalizeChildren(vnodes) {
    var loop = function (vnodes) {
        if (isArray(vnodes)) {
            var ret_1 = [];
            vnodes.forEach(function (vnode) {
                if (isArray(vnode)) {
                    ret_1.push.apply(ret_1, loop(vnode));
                }
                else {
                    ret_1.push(normalize(vnode));
                }
            });
            return ret_1;
        }
        return normalize(vnodes);
    };
    var ret = loop(vnodes);
    if (isArray(ret)) {
        var l = ret.length;
        return l === 0 ? undefined : l === 1 ? ret[0] : ret;
    }
    return ret;
}
function normalizeProps(vnode) {
    var componentOptions = vnode.componentOptions, data = vnode.data;
    var attrs = data.attrs;
    var propTypes = componentOptions.Ctor.typeDefs;
    var props = {};
    if (attrs) {
        for (var key in attrs) {
            if (~['staticClass', 'class', 'style', 'staticStyle'].indexOf(key))
                continue;
            var value = attrs[key];
            if (propTypes) {
                var camelizedKey = camelize(key);
                if (hasOwn.call(propTypes, camelizedKey)) {
                    value = normalizeBoolean(propTypes, key, camelizedKey, value);
                    key = camelizedKey;
                }
            }
            props[key] = value;
        }
    }
    normalizeClassName(data, props);
    normalizeStyle(data, props);
    normalizeSlots(vnode, componentOptions.children, data.scopedSlots, props);
    normalizeEvents(componentOptions.listeners, props);
    normalizeRef(data, vnode.context.$refs, props);
    normalizeKey(data, vnode, props);
    normalizeDirs(data.directives, props);
    return props;
}
function normalizeClassName(data, props) {
    if (data) {
        var staticClass = data.staticClass || data._staticClass;
        if (staticClass) {
            props.className = staticClass;
            // Vue will merge class with parent class, so we assign it to
            // _staticClass and delete the original staticClass to prevent from merging.
            // So that we can use _staticClass instead when it comes here again
            data._staticClass = staticClass;
            delete data.staticClass;
        }
        var className = data.class || data._class;
        if (className) {
            if (!props.className) {
                props.className = stringifyClass(className);
            }
            else {
                props.className += ' ' + stringifyClass(className);
            }
            data._class = className;
            delete data.class;
        }
    }
}
function normalizeStyle(data, props) {
    var result;
    if (data) {
        var style = data.style || data._style;
        if (style) {
            result = getStyleBinding(style);
            data._style = style;
            delete data.style;
        }
        var staticStyle = data.staticStyle || data._staticStyle;
        if (staticStyle) {
            result = __assign(__assign({}, staticStyle), style);
            data._staticStyle = staticStyle;
            delete data.staticStyle;
        }
    }
    if (result) {
        props.style = result;
    }
}
function normalizeBoolean(propTypes, key, camelizedKey, value) {
    var tmp;
    if ((
    // value is Boolean
    (tmp = propTypes[camelizedKey]) === Boolean ||
        tmp && (
        // value contains Boolean
        isArray(tmp) && tmp.indexOf(Boolean) > -1 ||
            (tmp = tmp.type) && (
            // value.type is Boolean
            tmp === Boolean ||
                // value.type contains Boolean
                isArray(tmp) && tmp.indexOf(Boolean) > -1))) &&
        (value === '' || value === key)) {
        value = true;
    }
    return value;
}
function normalizeEvents(listeners, props) {
    if (listeners) {
        var _loop_1 = function (key) {
            var name_1 = void 0;
            var value = listeners[key];
            var cb = isArray(value) ?
                function (v) {
                    value.forEach(function (value) { return value(v); });
                } :
                value;
            if (key === 'input') {
                // is a v-model directive of vue
                name_1 = "$model:value";
            }
            else if (key.startsWith('update:')) {
                // delegate update:prop(sync modifier) to $change:prop.
                // propName has been camelized by Vue, don't do it again
                // key = `$change:${camelize(key.substr(7))}`;
                var propName = key.substring(7);
                // if (name.indexOf('-') > -1) continue;
                name_1 = "$model:".concat(propName);
            }
            else {
                if (key.startsWith('change:')) {
                    name_1 = "$change:".concat(camelize(key.substring(7)));
                }
                else {
                    if (key === 'change') {
                        name_1 = key;
                    }
                    else if (key.startsWith('change')) {
                        // e.g. @changeValue -> ev-$change:value
                        // e.g. @changePropName -> ev-$change:propName
                        // e.g. @change-prop-name -> ev-$change:propName
                        name_1 = "$change:".concat(lowerFirst(camelize(key.substring(6))));
                    }
                    else {
                        name_1 = camelize(key);
                    }
                }
            }
            props["ev-".concat(name_1)] = cb;
        };
        for (var key in listeners) {
            _loop_1(key);
        }
    }
}
function normalizeSlots(vnode, children, scopedSlots, props) {
    var slots = vnode.$slots || resolveSlots(children);
    var blocks = null;
    var _loop_2 = function (key) {
        var slot = slots[key];
        if (key === 'default') {
            props.children = normalizeChildren(slot);
            return "continue";
        }
        if (!blocks)
            blocks = {};
        blocks[key] = function () {
            return normalizeChildren(slot);
        };
    };
    for (var key in slots) {
        _loop_2(key);
    }
    if (scopedSlots) {
        var _loop_3 = function (key) {
            var slot = scopedSlots[key];
            if (!blocks)
                blocks = {};
            blocks[key] = function (parent, data) {
                return normalizeChildren(slot(data));
            };
        };
        for (var key in scopedSlots) {
            _loop_3(key);
        }
    }
    if (blocks) {
        props.$blocks = blocks;
    }
}
function normalizeRef(data, refs, props) {
    var ref = data.ref;
    if (ref) {
        props.ref = function (i, isRemove) {
            var value = refs[ref];
            if (!isRemove) {
                if (data.refInFor) {
                    if (!isArray(value)) {
                        refs[ref] = [i];
                    }
                    else if (value.indexOf(i) < 0) {
                        value.push(i);
                    }
                }
                else {
                    refs[ref] = i;
                }
            }
            else {
                if (isArray(value)) {
                    var index = value.indexOf(i);
                    if (~index) {
                        value.splice(index, 1);
                    }
                }
                else {
                    refs[ref] = undefined;
                }
            }
        };
        props.ref.key = ref;
    }
}
function normalizeDirs(dirs, props) {
    if (!dirs)
        return;
    dirs.find(function (dir) {
        if (dir.name === 'show' && !dir.value) {
            (props.style || (props.style = {})).display = 'none';
            return true;
        }
    });
}
function normalizeKey(data, vnode, props) {
    if (!isNullOrUndefined(data.key)) {
        props.key = data.key;
    }
    else if (!isNullOrUndefined(vnode.key)) {
        props.key = vnode.key;
    }
}
// copy from vue/src/core/instance/render-helpers/resolve-slots.js
function resolveSlots(children) {
    var slots = {};
    if (!children) {
        return slots;
    }
    for (var i = 0, l = children.length; i < l; i++) {
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) {
            delete data.attrs.slot;
        }
        if (data && data.slot != null) {
            var name_2 = data.slot;
            var slot = (slots[name_2] || (slots[name_2] = []));
            if (child.tag === 'template') {
                slot.push.apply(slot, child.children || []);
            }
            else {
                slot.push(child);
            }
        }
        else {
            (slots.default || (slots.default = [])).push(child);
        }
    }
    // ignore slots that contains only whitespace
    for (var name_3 in slots) {
        if (slots[name_3].every(isWhitespace)) {
            delete slots[name_3];
        }
    }
    return slots;
}
function isIntactComponent(vnode) {
    var componentOptions = vnode.componentOptions;
    return componentOptions &&
        componentOptions.Ctor.$cid === 'IntactVue';
}
function isIntactVNode(vNode) {
    return 'type' in vNode;
}
function isWhitespace(node) {
    return (node.isComment && !node.asyncFactory) || node.text === ' ';
}
function stringifyClass(className) {
    if (isNullOrUndefined(className))
        return '';
    if (isArray(className)) {
        return stringifyArray(className);
    }
    if (typeof className === 'object') {
        return stringifyObject(className);
    }
    if (typeof className === 'string') {
        return className;
    }
    return '';
}
function stringifyArray(value) {
    var res = '';
    var stringified;
    for (var i = 0; i < value.length; i++) {
        if ((stringified = stringifyClass(value[i])) != null && stringified !== '') {
            if (res)
                res += ' ';
            res += stringified;
        }
    }
    return res;
}
function stringifyObject(value) {
    var res = '';
    for (var key in value) {
        if (value[key]) {
            if (res)
                res += ' ';
            res += key;
        }
    }
    return res;
}
function cached(fn) {
    var cache = Object.create(null);
    return function (str) {
        return cache[str] || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
    return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; });
});
var lowerFirst = cached(function (str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
});
function isBoolean(o) {
    return o === true || o === false;
}
function getStyleBinding(style) {
    if (isArray(style)) {
        return toObject(style);
    }
    if (typeof style === 'string') {
        return parseStyleText(style);
    }
    return style;
}
function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            Object.assign(res, arr[i]);
        }
    }
    return res;
}
var listDelimiter = /;(?![^(]*\))/g;
var propertyDelimiter = /:(.+)/;
var parseStyleText = cached(function (cssText) {
    var res = {};
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});

function functionalWrapper(Component) {
    function Ctor(props) {
        return Component(props);
    }
    Ctor.options = {
        functional: true,
        render: function (h, props) {
            var _props = normalizeProps({
                componentOptions: {
                    Ctor: Component,
                    listeners: props.listeners,
                },
                data: props.data,
                $slots: props.slots(),
                context: props.parent,
            });
            // functional component of intact must return VNodeComponentClass
            var vNode = Component(_props, true);
            if (isArray(vNode)) {
                return vNode.map(function (vNode) { return toVueVNode(h, vNode, props); });
            }
            return toVueVNode(h, vNode, props);
        }
    };
    Ctor.cid = 'IntactFunctionalComponent';
    return Ctor;
}
function toVueVNode(h, vNode, props) {
    var attrs = {};
    var __props = { attrs: attrs };
    var vNodeProps = vNode.props || EMPTY_OBJ;
    for (var key in vNodeProps) {
        if (~['children', '_context', 'className', 'style', 'ref', 'key'].indexOf(key))
            continue;
        attrs[key] = vNodeProps[key];
    }
    if (vNode.ref) {
        __props.ref = props.data.ref;
    }
    if (vNodeProps.className) {
        __props.staticClass = vNodeProps.className;
    }
    if (vNodeProps.style) {
        __props.staticStyle = vNodeProps.style;
    }
    if (!isNullOrUndefined(vNode.key)) {
        __props.key = vNode.key;
    }
    var children = vNodeProps.children;
    if (children && !isArray(children)) {
        children = [children];
    }
    return h(vNode.tag, __props, children);
}

function addMeta(element, first, second) {
    element._intactVueLegacyFirst = first;
    element._intactVueLegacySecond = second;
}
function rewriteDomApi(element) {
    var first = element._intactVueLegacyFirst, second = element._intactVueLegacySecond;
    var parentNode = first.parentNode;
    Object.defineProperty(element, 'parentNode', {
        value: parentNode,
    });
    Object.defineProperty(element, 'nextSibling', {
        get: function () {
            return second.nextSibling;
        }
    });
    rewriteParentApi(parentNode);
}
function rewriteParentApi(parentNode) {
    if (parentNode._intactVueLegacyRewrote)
        return;
    var removeChild = parentNode.removeChild;
    parentNode.removeChild = function (child) {
        if (isFragmentWithMeta(child)) {
            removeChild.call(this, child._intactVueLegacyFirst);
            return removeChild.call(this, child._intactVueLegacySecond);
        }
        return removeChild.call(this, child);
    };
    var insertBefore = parentNode.insertBefore;
    parentNode.insertBefore = function (newChild, refChild) {
        if (refChild && isFragmentWithMeta(refChild)) {
            return insertBefore.call(this, newChild, refChild._intactVueLegacyFirst);
        }
        return insertBefore.call(this, newChild, refChild);
    };
    parentNode._intactVueLegacyRewrote = true;
}
function isFragmentWithMeta(node) {
    return '_intactVueLegacyFirst' in node;
}

var currentInstance = null;
var _a = createStack(), pushMountedQueue = _a[0], popMountedQueue = _a[1], mountedQueueStack = _a[2];
var Component = /*#__PURE__*/ /*#__PURE__*/ /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component(props, $vNode, $SVG, $mountedQueue, $senior) {
        var _this = this;
        var vnode = props && props._parentVnode;
        if (vnode) {
            $mountedQueue = pushMountedQueue([]);
            var vNode_1 = normalize(vnode);
            var $senior_1 = getIntactParent(props.parent);
            _this = _super.call(this, vNode_1.props, vNode_1, $SVG, $mountedQueue, $senior_1) || this;
            _this.$isVue = true;
            _this._vnode = {};
            if (process.env.NODE_ENV !== 'production') {
                validateProps(_this.$vNode);
            }
            _this.$options = props;
            var isDoubleVNodes_1 = _this.constructor.$doubleVNodes;
            props.render = function (h) {
                var subTree = h();
                subTree.data = {
                    hook: {
                        prepatch: function (oldVnode, vnode) {
                            var mountedQueue = _this.$isForceUpdating ? _this.$mountedQueue : (_this.$mountedQueue = pushMountedQueue([]));
                            var vNode = normalize(_this.$vnode);
                            var lastVNode = _this.$vNode;
                            _this.$vNode = vNode;
                            vNode.children = _this;
                            if (process.env.NODE_ENV !== 'production') {
                                validateProps(_this.$vNode);
                            }
                            _this.$update(lastVNode, vNode, _this.$el.parentElement, null, mountedQueue, false, true);
                            // element may have chagned
                            // only check if the component returns only one vNode
                            if (!isDoubleVNodes_1) {
                                var element = findDomFromVNode(vNode, true);
                                if (oldVnode.elm !== element) {
                                    _this.$vnode.elm = vnode.elm = oldVnode.elm = element;
                                    // set scope id
                                    if (_this.$scopeId && element.nodeType === 1) {
                                        element.setAttribute(_this.$scopeId, '');
                                    }
                                }
                            }
                        }
                    }
                };
                if (!_this._isMounted) {
                    var nativeCreateComment_1 = document.createComment;
                    document.createComment = function () {
                        document.createComment = nativeCreateComment_1;
                        _this.$init(vNode_1.props);
                        vNode_1.children = _this;
                        _this.$render(null, vNode_1, null, null, $mountedQueue);
                        var element = findDomFromVNode(vNode_1, true);
                        if (isDoubleVNodes_1) {
                            var first = element;
                            var second = findDomFromVNode(vNode_1, false);
                            var container = document.createDocumentFragment();
                            container.appendChild(first);
                            container.appendChild(second);
                            element = container;
                            addMeta(element, first, second);
                        }
                        // Because we make all Intact Components be patchable,
                        // Vue will setScopeId on it, but Intact component may
                        // create a text or comment node. We add setAttribute
                        // method to these nodes to prevent Vue from throwing error
                        // when set scope id on them and save the scopeId to add it
                        // when component updated.
                        if (element.nodeType !== 1) {
                            Object.defineProperty(element, 'setAttribute', {
                                value: function (scopeId) {
                                    _this.$scopeId = scopeId;
                                }
                            });
                        }
                        return element;
                    };
                }
                else {
                    // We have make it patchable in $mounted,
                    // set its tag as 'div' to make them to be same vnodes
                    subTree.tag = 'fake-div';
                }
                // set parent always to null, to make Vue call invokeInsertHook
                // don't overwrite the pendingInsert array
                Object.defineProperty(subTree, 'parent', {
                    get: function () { return null; },
                    set: noop,
                });
                return subTree;
            };
            Vue.prototype._init.call(_this, props);
            // force Vue update Intact component, and prevent Vue from changing it 
            Object.defineProperty(_this.$options, '_renderChildren', {
                get: function () { return true; },
                set: noop
            });
            // (this.$options as any)._renderChildren = true;
            _this.$options.mounted = [function () {
                    if (isDoubleVNodes_1) {
                        rewriteDomApi(_this.$el);
                    }
                    // if Vue has called the insertedQueue, remove the queue to 
                    // avoid Intact call it again on updating 
                    _this.$vnode.data.queue = null;
                    callMountedQueue();
                }];
            _this.$options.updated = [function () {
                    callMountedQueue();
                }];
            // disable async component 
            _this.$inited = true;
        }
        else {
            _this = _super.call(this, props, $vNode, $SVG, $mountedQueue, $senior) || this;
        }
        return _this;
    }
    Object.defineProperty(Component, "options", {
        // Vue will read props from Constructor's options
        // static options = {...(Vue as any).options, inheritAttrs: false};
        // Some libraries will extend Vue.options, so we have to use getter to get options
        get: function () { return __assign(__assign({}, Vue.options), { inheritAttrs: false }); },
        enumerable: false,
        configurable: true
    });
    Component.prototype.$render = function (lastVNode, nextVNode, parentDom, anchor, mountedQueue) {
        var popInstance = pushInstance(this);
        _super.prototype.$render.call(this, lastVNode, nextVNode, parentDom, anchor, mountedQueue);
        popInstance();
    };
    Component.prototype.$mount = function (lastVNode, nextVNode) {
        if (isBoolean(nextVNode)) {
            // called by Vue
            Vue.prototype.$mount.call(this, lastVNode, nextVNode);
            // make it patchable to add native events and setScopeId
            this._vnode.tag = 'fake-div';
            return this;
        }
        else {
            _super.prototype.$mount.call(this, lastVNode, nextVNode);
        }
    };
    Component.prototype.$update = function (lastVNode, nextVNode, parentDom, anchor, mountedQueue, force, fromPrepatch) {
        if (this.$isVue && !fromPrepatch) {
            this.$isForceUpdating = true;
            this._$update();
            this.$isForceUpdating = false;
        }
        else {
            var popInstance = pushInstance(this);
            _super.prototype.$update.call(this, lastVNode, nextVNode, parentDom, anchor, mountedQueue, force);
            if (force) {
                var senior = this;
                while (senior = senior.$senior) {
                    if (senior.$isVue) {
                        callInsertQueue(senior.$vnode);
                        break;
                    }
                }
            }
            popInstance();
        }
    };
    Component.prototype.$forceUpdate = function () {
        this._$update();
        callMountedQueue();
    };
    Component.prototype.$destroy = function () {
        Vue.prototype.$destroy.call(this);
        this.$unmount(this.$vNode, null);
    };
    Component.prototype._$update = function () {
        this._update(this._render(), false);
        callInsertQueue(this.$vnode);
    };
    // If cid does not exist, Vue will treat it as an async component 
    Component.cid = 'IntactVue';
    // Need by devtools
    Component.config = Vue.config;
    Component.$cid = 'IntactVue';
    Component.$doubleVNodes = false;
    Component.normalize = normalizeChildren;
    Component.functionalWrapper = functionalWrapper;
    return Component;
}(Component$1));
var prototype = Component.prototype;
var vuePrototype = Vue.prototype;
prototype._render = vuePrototype._render;
prototype._update = vuePrototype._update;
prototype.__patch__ = vuePrototype.__patch__;
// prototype.$forceUpdate = vuePrototype.$forceUpdate;
// prototype.$destroy = vuePrototype.$destroy;
// mock api
prototype.$on = noop;
prototype.$off = noop;
function createStack() {
    var stack = [];
    function pushStack(item) {
        stack.push(item);
        // console.log('push', stack.length);
        return item;
    }
    function popStack() {
        // console.log('pop', stack.length);
        return stack.pop();
    }
    return [pushStack, popStack, stack];
}
function callMountedQueue() {
    var mountedQueue = popMountedQueue();
    /* istanbul ignore next */
    if (process.env.NODE_ENV !== 'production') {
        if (!mountedQueue) {
            throw new Error("\"mountedQueue\" is undefined, maybe this is a bug of Intact-Vue");
        }
    }
    callAll(mountedQueue);
}
var _b = createStack(), _pushInstance = _b[0], _popInstance = _b[1];
function pushInstance(instance) {
    var lastIntance = currentInstance;
    currentInstance = _pushInstance(instance);
    return function () {
        _popInstance();
        currentInstance = lastIntance;
    };
}
function getIntactParent(parent) {
    if (currentInstance) {
        return currentInstance;
    }
    // maybe we mount/update a intact component in Vue component
    while (parent) {
        if (parent instanceof Component) {
            return parent;
        }
        parent = parent.$parent;
    }
    return null;
}
function callInsertQueue(vnode) {
    var data = vnode.data;
    var pendingInsert = data.queue;
    if (pendingInsert) {
        pendingInsert.forEach(function (vnode) {
            vnode.data.hook.insert(vnode);
        });
        data.queue = null;
    }
}

export { Component, mountedQueueStack, normalizeChildren as normalize };
